<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
        type="email"
        class="form-control"
        :id="inputId"
        :disabled="disabled"
        v-model="inputValue"
    />
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'OrganizationWebsiteInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin
  ],

  props: {
    inputLabel: {
      default: 'Сайт'
    },

    inputName: {
      default: 'website'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId() {
      return 'form-organization-website'
    }
  }
}
</script>
